import * as v from "valibot";

// request
export const RequestSchema = v.object({
  Action: v.nullish(v.string()),
  Page: v.nullish(v.string()),
  PageSize: v.nullish(v.string()),
  Search: v.nullish(v.string()),
  Version: v.nullish(v.string()),
});
export type Request = v.InferOutput<typeof RequestSchema>;

// ── response sub-schemas (independent from DescribeClusters) ──
export const SchedulerSchema = v.object({
  Reason: v.string(),
  Status: v.string(),
});
export type Scheduler = v.InferOutput<typeof SchedulerSchema>;

export const EventEtcdSchema = v.object({
  Reason: v.string(),
  Status: v.string(),
});
export type EventEtcd = v.InferOutput<typeof EventEtcdSchema>;

export const EtcdSchema = v.object({
  Reason: v.string(),
  Status: v.string(),
});
export type Etcd = v.InferOutput<typeof EtcdSchema>;

export const ControllerManagerSchema = v.object({
  Reason: v.string(),
  Status: v.string(),
});
export type ControllerManager = v.InferOutput<typeof ControllerManagerSchema>;

export const ApiServerSchema = v.object({
  Reason: v.string(),
  Status: v.string(),
});
export type ApiServer = v.InferOutput<typeof ApiServerSchema>;

export const ComponentStatusSchema = v.object({
  ApiServer: v.nullish(ApiServerSchema),
  ControllerManager: v.nullish(ControllerManagerSchema),
  Etcd: v.nullish(EtcdSchema),
  EventEtcd: v.nullish(EventEtcdSchema),
  Scheduler: v.nullish(SchedulerSchema),
});
export type ComponentStatus = v.InferOutput<typeof ComponentStatusSchema>;

export const StatusSchema = v.object({
  ClusterStatus: v.string(),
  ComponentStatus: v.nullish(ComponentStatusSchema),
  Message: v.string(),
  Phase: v.string(),
  Reason: v.string(),
  ToDelete: v.boolean(),
  ToRemove: v.boolean(),
});
export type Status = v.InferOutput<typeof StatusSchema>;

export const PublicApiServerStatusSchema = v.object({
  PhaseOfApiServer: v.string(),
  PubAccessOperationPhase: v.string(),
});
export type PublicApiServerStatus = v.InferOutput<typeof PublicApiServerStatusSchema>;

export const OrderInfoSchema = v.object({
  ChargeType: v.string(),
  OrderId: v.string(),
  Unit: v.number(),
});
export type OrderInfo = v.InferOutput<typeof OrderInfoSchema>;

export const NetworkSchema = v.object({
  IsPrivateSlbKceCreate: v.boolean(),
  IsPublicSlbKceCreate: v.boolean(),
  IsPubPriUnified: v.boolean(),
  IsSecurityGroupKceCreate: v.boolean(),
  LbType: v.string(),
  PrivateApiserverIp: v.string(),
  PrivateSlbId: v.string(),
  PrivateSlbReason: v.string(),
  PrivateSlbStatus: v.string(),
  PublicAclStatus: v.string(),
  PublicApiserverIp: v.string(),
  PublicSlbId: v.string(),
  PublicSlbReason: v.string(),
  PublicSlbStatus: v.string(),
  PublicStatus: v.string(),
  ReserveSubnetId: v.string(),
  SANStatus: v.string(),
  SecurityGroupId: v.string(),
  SecurityGroupName: v.string(),
  VpcCIDR: v.string(),
  VpcId: v.string(),
  VpcName: v.string(),
});
export type Network = v.InferOutput<typeof NetworkSchema>;

export const SubnetInfoSchema = v.object({
  SubnetId: v.string(),
  Zone: v.string(),
});
export type SubnetInfo = v.InferOutput<typeof SubnetInfoSchema>;

export const ClusterSetManagedClusterSpecSchema = v.object({
  ApiServerMemory: v.string(),
  AutoScaleConfig: v.record(v.string(), v.any()),
  ClusterEdition: v.string(),
  ETCDNum: v.number(),
  Monitor: v.record(v.string(), v.any()),
  SecurityGroupIDs: v.array(v.string()),
  SubnetInfos: v.array(SubnetInfoSchema),
});
export type ClusterSetManagedClusterSpec = v.InferOutput<typeof ClusterSetManagedClusterSpecSchema>;

export const MonitoringUpdateStrategySchema = v.object({
  RollingUpdate: v.record(v.string(), v.any()),
});
export type MonitoringUpdateStrategy = v.InferOutput<typeof MonitoringUpdateStrategySchema>;

export const MonitoringSchema = v.object({
  UpdateStrategy: MonitoringUpdateStrategySchema,
});
export type Monitoring = v.InferOutput<typeof MonitoringSchema>;

export const KubernetesNetworkPluginSchema = v.object({
  MaxPodPerNode: v.number(),
  PodCidr: v.string(),
  ServiceCidr: v.string(),
  Type: v.string(),
});
export type KubernetesNetworkPlugin = v.InferOutput<typeof KubernetesNetworkPluginSchema>;

export const DnsUpdateStrategySchema = v.object({
  RollingUpdate: v.record(v.string(), v.any()),
});
export type DnsUpdateStrategy = v.InferOutput<typeof DnsUpdateStrategySchema>;

export const DnsSchema = v.object({
  LinearAutoscalerParams: v.record(v.string(), v.any()),
  UpdateStrategy: DnsUpdateStrategySchema,
});
export type Dns = v.InferOutput<typeof DnsSchema>;

export const ContainerSchema = v.object({
  Runtime: v.string(),
});
export type Container = v.InferOutput<typeof ContainerSchema>;

export const BastionHostSchema = v.object({
  Order: v.number(),
  Password: v.string(),
  Port: v.number(),
});
export type BastionHost = v.InferOutput<typeof BastionHostSchema>;

export const KubernetesSchema = v.object({
  BastionHost: BastionHostSchema,
  Container: ContainerSchema,
  DNS: DnsSchema,
  K8SVersionId: v.string(),
  KubernetesNetworkPlugin: KubernetesNetworkPluginSchema,
  KubernetesVersion: v.string(),
  Monitoring: MonitoringSchema,
  NodeNameMode: v.string(),
});
export type Kubernetes = v.InferOutput<typeof KubernetesSchema>;

export const ClusterObservabilityManagedClusterSpecSchema = v.object({
  AutoScaleConfig: v.record(v.string(), v.any()),
  Monitor: v.record(v.string(), v.any()),
});
export type ClusterObservabilityManagedClusterSpec = v.InferOutput<
  typeof ClusterObservabilityManagedClusterSpecSchema
>;

export const ClusterObservabilitySchema = v.object({
  IsClusterMonitor: v.boolean(),
  LogInfo: v.record(v.string(), v.any()),
  ManagedClusterSpec: ClusterObservabilityManagedClusterSpecSchema,
});
export type ClusterObservability = v.InferOutput<typeof ClusterObservabilitySchema>;

export const ClusterSetSchema = v.object({
  // "Addons": v.optional(v.null()),
  ClusterDesc: v.nullish(v.string()),
  ClusterId: v.string(),
  ClusterManageMode: v.string(),
  ClusterName: v.string(),
  // "ClusterObservability": v.optional(v.union([ClusterObservabilitySchema, v.null()])),
  CreatedTime: v.string(),
  IsDeleteProtect: v.boolean(),
  IsKceEventCollecting: v.nullish(v.boolean()),
  Kubernetes: KubernetesSchema,
  LogInfo: v.nullish(v.record(v.string(), v.any())),
  // "ManagedClusterSpec": v.optional(v.union([ClusterSetManagedClusterSpecSchema, v.null()])),
  MigrateSource: v.optional(v.picklist(["KCE1", "NONE"])),
  Network: v.nullish(NetworkSchema),
  // "NodeInstanceSet": v.optional(v.null()),
  NodeNum: v.number(),
  // "OrderInfo": OrderInfoSchema,
  ProjectID: v.nullish(v.string()),
  PublicApiServerStatus: v.nullish(PublicApiServerStatusSchema),
  ReadyNodeNum: v.number(),
  Status: StatusSchema,
  UpdatedTime: v.nullish(v.string()),
  // "VpcCniAddon": v.optional(v.null()),
});
export type ClusterSet = v.InferOutput<typeof ClusterSetSchema>;

export const DataSchema = v.object({
  ClusterSet: v.array(ClusterSetSchema),
  Marker: v.number(),
  MaxResults: v.number(),
  Page: v.number(),
  PageSize: v.number(),
  RequestId: v.string(),
  TotalCount: v.number(),
});
export type Data = v.InferOutput<typeof DataSchema>;

export const ResponseSchema = v.object({
  Data: DataSchema,
  RequestId: v.string(),
});
export type Response = v.InferOutput<typeof ResponseSchema>;
